import React, {useEffect, useState} from "react";
import {Button, Col, FormGroup, Label, Row, Spinner} from "reactstrap";
import {FormControl} from "react-bootstrap";
import Select from "react-select";
import {degrees} from "../../util/Degrees";
import {qualifications, UniversitiesList} from "../../util/UniversitiesList";
import {getSelectedObject} from "../../util/Helper";
import {years} from "../../util/Years";
import {NotificationManager} from "react-notifications";

const Education = (props) => {
  const [education, setEducation] = useState({});

  useEffect(() => {
      console.log({...props.education});
    setEducation({ ...props.candidate });
  }, []);

    const isFieldEnabled = (fieldName) =>
        props.education.fields[fieldName]?.enabled;

    const theLabelName = (fieldName) => props.education.fields[fieldName]?.label;

    useEffect(() => {
    }, [education]);

  const handleChange = (e) => {
    setEducation({
      ...education,
      [e.target.name]: e.target.value,
    });
  };

  const handleValidation = () => {
      const {
          degree,
          institute,
          cgpa,
          specialization,
          graduationYear,
          resume,
          qualification,
      } = education;

    // Check if all fields are filled
    if (
        (isFieldEnabled("degree") && !degree) ||
        (isFieldEnabled("institute") && !institute) ||
        (isFieldEnabled("cgpa") && !cgpa) ||
        (isFieldEnabled("specialization") && !specialization) ||
        (isFieldEnabled("graduationYear") && !graduationYear) ||
        (isFieldEnabled("resume") && !resume) ||
        (isFieldEnabled("qualification") && !qualification)
    ) {
        // NotificationManager.error("Please fill in all the required fields.");
      return false;
    }

      // All required fields are valid
    return true;
  };


    // const handleValidation = () => {
    //   const {
    //     degree,
    //     institute,
    //     cgpa,
    //     specialization,
    //     graduationYear,
    //     resume,
    //     qualification,
    //   } = education;

    //   // Check if all fields are filled
    //   if (
    //     !degree ||
    //     !institute ||
    //     !cgpa ||
    //     !specialization ||
    //     !graduationYear ||
    //     !qualification ||
    //     !resume
    //   ) {
    //     return false;
    //   }

    //   // All fields are present, continue with further logic
    //   return true;
    // };

    const handleNext = () => {
    if (handleValidation()) {
        props.setCandidate({...props.candidate, ...education});

        // props.setProgress(33);

        const newProgress = (props.progress || 0) + props.progressIncrement;
        props.setProgress(newProgress);

        props.setStep(3);
      let temp = { ...props.isCompleted };
      temp.education = true;
      props.setIsCompleted(temp);
        props.switchComponent("experience");
        props.gotoSlide(2);
    } else {
      NotificationManager.error("Please fill in all the required fields.");
    }
  };

    const handleFinal = async () => {
        if (handleValidation()) {
            let temp = {...props.isCompleted, education: true};
            props.setIsCompleted(temp);
            const completeData = {...props.candidate, ...education};
            props.setCandidate(completeData);
            await props.handleSubmit(completeData);
        } else {
            NotificationManager.error("Please fill in all the required fields.");
        }
    };

  return (
    <div className="d-flex justify-content-between">
      <Col className=" px-lg-2 mt-lg-2 pt-lg-2">
        <div className={"text-center"}>
          <h3 className="secondary-heading">
            Please, enter your educational information
          </h3>
        </div>
          <Row className="grid-row mt-4">
              {isFieldEnabled("degree") && (
                  <Col md={12}>
                      <FormGroup>
                          {/* previously, the commented ones were the labels and placeholders. Now I have replaced them with the theLabelName("label") of the respective field */}
                          <Row>
                              <Col>
                                  <Label className="float-sm-left ml-3">
                                      <strong>
                                          {theLabelName("degree")} :{" "}
                                          <span className={"active-text"}>*</span>
                                      </strong>
                                  </Label>
                              </Col>
                          </Row>
                          <Row>
                              <Col>
                                  <Select
                                      className="react-select primary -border-none text-left input-grey-p-0"
                                      classNamePrefix="react-select"
                                      name={"degree"}
                                      options={degrees}
                                      value={getSelectedObject(education?.degree, degrees)}
                                      onChange={(selectedOption) => {
                                          setEducation({
                                              ...education,
                                              degree: selectedOption?.value,
                                              degree_insensitive: selectedOption?.value.toLowerCase(),
                                          });
                                      }}
                                  />
                              </Col>
                          </Row>
                      </FormGroup>
                  </Col>
              )}
              {isFieldEnabled("qualification") && (
                  <Col md={12}>
                      <FormGroup>
                          <Row>
                              <Col>
                                  <Label className="float-sm-left ml-3">

                                      <strong>
                                          {theLabelName("qualification")} :{" "}
                        <span className={"active-text"}>*</span>
                                      </strong>
                                  </Label>
                              </Col>
                          </Row>
                          <Row>
                              <Col>
                                  <Select
                      className="react-select primary -border-none text-left input-grey-p-0"
                      classNamePrefix="react-select"
                      name={"qualification"}
                      options={qualifications}
                      value={getSelectedObject(
                          education?.qualification,
                          qualifications
                      )}
                      onChange={(selectedOption) => {
                          setEducation({
                              ...education,
                              qualification: selectedOption?.value,
                          });
                      }}
                                  />
                              </Col>
                          </Row>
                      </FormGroup>
                  </Col>
              )}


              {isFieldEnabled("cgpa") && (
                  <Col md={12}>
                      <FormGroup>
                          <Row>
                              <Col>
                                  <Label className="float-sm-left ml-3">
                                      <strong>
                                          {theLabelName("cgpa")} :{" "}
                                          <span className={"active-text"}>*</span>
                                      </strong>
                                  </Label>
                              </Col>
                          </Row>
                          <Row>
                              <Col>
                                  <FormControl
                      type="number"
                      className="input-grey"
                      name={"cgpa"}
                      placeholder={theLabelName("cgpa")}
                      value={education?.cgpa}
                      onChange={(e) => {
                          if (e.target.value > 4) {
                              e.target.value = 4;
                          }
                        handleChange(e);
                      }}
                                  />
                              </Col>
                          </Row>
                      </FormGroup>
                  </Col>
              )}
              {isFieldEnabled("specialization") && (
                  <Col md={12}>
                      <FormGroup>
                          <Row>
                              <Col>
                                  <Label className="float-sm-left ml-3">
                                      <strong>
                                          {theLabelName("specialization")} :{" "}
                                          <span className={"active-text"}>*</span>
                                      </strong>
                                  </Label>
                              </Col>
                          </Row>
                          <Row>
                              <Col>
                                  <FormControl
                                      className={"input-grey"}
                                      name={"specialization"}
                                      onChange={(e) => handleChange(e)}
                                      placeholder={theLabelName("specialization")}
                                      value={education?.specialization}
                                  />

                                  {/*<Select*/}
                                  {/*  className="react-select primary -border-none text-left input-grey-p-0"*/}
                                  {/*  classNamePrefix="react-select"*/}
                                  {/*  name="specialization"*/}
                                  {/*  options={specializationList}*/}
                                  {/*  value={getSelectedObject(*/}
                                  {/*    education?.specialization,*/}
                                  {/*    specializationList*/}
                                  {/*  )}*/}
                                  {/*  onChange={(selectedOption) => {*/}
                                  {/*    setEducation({*/}
                                  {/*      ...education,*/}
                                  {/*      specialization: selectedOption?.value,*/}
                                  {/*    });*/}
                                  {/*  }}*/}
                                  {/*/>*/}
                              </Col>
                          </Row>
                      </FormGroup>
                  </Col>
              )}
              {isFieldEnabled("graduationYear") && (
                  <Col md={12}>
                      <FormGroup>
                          <Row>
                              <Col>
                                  <Label className="float-sm-left ml-3">
                                      <strong>
                                          {theLabelName("graduationYear")} :{" "}
                                          <span className={"active-text"}>*</span>

                                      </strong>
                                  </Label>
                              </Col>
                          </Row>
                          <Row>
                              <Col>
                                  <Select
                                      className="react-select primary -border-none text-left input-grey-p-0"
                                      classNamePrefix="react-select"
                                      name={"graduationYear"}
                                      options={years}
                                      value={getSelectedObject(education?.graduationYear, years)}
                                      onChange={(selectedOption) => {
                                          setEducation({
                                              ...education,
                                              graduationYear: selectedOption?.value,
                                          });
                                      }}
                                  />
                              </Col>
                          </Row>
                      </FormGroup>
                  </Col>
              )}

              {isFieldEnabled("institute") && (
                  <Col md={12}>
                      <FormGroup>
                          <Row>
                              <Col>
                                  <Label className="float-sm-left ml-3">
                                      <strong>
                                          {theLabelName("institute")} :{" "}
                                          <span className={"active-text"}>*</span>
                                      </strong>
                                  </Label>
                              </Col>
                          </Row>
                          <Row>
                              <Col>
                                  <Select
                      className="react-select primary -border-none text-left input-grey-p-0"
                      classNamePrefix="react-select"
                      name="institute"
                      options={UniversitiesList}
                      value={getSelectedObject(
                          education?.institute,
                          UniversitiesList
                      )}
                      onChange={(selectedOption) => {
                          setEducation({
                              ...education,
                              institute: selectedOption?.value,
                          });
                      }}
                                  />
                              </Col>
                          </Row>
                      </FormGroup>
                  </Col>
              )}

        </Row>
          {/*<Row>*/}
          {/*  <Col md={12}>*/}
          {/*    <Label className={"w-100 text-left ml-3"}>*/}
          {/*      <strong>*/}
          {/*        In case of any other degree, please specify details.*/}
          {/*      </strong>*/}
          {/*    </Label>*/}
          {/*    <textarea*/}
          {/*      className={"form-control input-grey"}*/}
          {/*      placeholder={*/}
          {/*        "In case of any other degree, please specify details"*/}
          {/*      }*/}
          {/*      style={{*/}
          {/*        borderRadius: "10px",*/}
          {/*      }}*/}
          {/*      name={"otherDegree"}*/}
          {/*      value={education?.otherDegree}*/}
          {/*      onChange={(e) => handleChange(e)}*/}
          {/*    ></textarea>*/}
          {/*  </Col>*/}
          {/*</Row>*/}

          {isFieldEnabled("resume") && (
              <Row className={"mt-lg-4"}>
                  <Col md={12}>
                      <Label className={"w-100 text-left ml-3"}>

                          <strong>
                              {theLabelName("resume")} :{" "}
                <span className={"active-text"}>*</span>
                              {/* Please, upload your resume.
                  <span className={"active-text"}>*</span> */}
                          </strong>
                      </Label>
                      {/*  accept files  */}
                      <div
                          onClick={() => {
                              document.getElementById("fileUpload").click();
                          }}
                          className={
                              "custom-input-file input-grey d-flex justify-content-between w-100 p-1 rounded"
                          }
                      >
                          <div className={"d-flex mt-2 px-2"}>
                              <i className="fa fa-paperclip mt-1 mr-2" aria-hidden="true"/>{" "}
                              <p
                                  className={"active-text"}
                                  style={{
                                      fontWeight: "600",
                                  }}
                              >
                                  <u>
                                      <strong>
                                          {education?.resume?.name
                                              ? education?.resume?.name
                                              : "Choose file"}
                                      </strong>
                                  </u>
                              </p>
                          </div>

                          <Button
                              className={"startButton px-5 py-0 text-white"}
                              color={""}
                              style={{
                                  background: "#fba51b",
                              }}
                          >
                              Upload
                          </Button>
                      </div>
                      <input
                          type="file"
                          id="fileUpload"
                          accept={".pdf,.doc,.docx,.jpg,.jpeg,.png,.gif,.tiff"}
                          name={"resume"}
                          style={{display: "none"}}
                          onChange={(e) => {
                              // check file size if greater than 1mb
                              if (!e.target.files[0]) return;
                              // check if the file has extension of pdf, doc, docx, jpg, jpeg, png, gif, tiff
                              if (
                                  ![
                                      "application/pdf",
                                      "application/msword",
                                      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                                      "image/jpeg",
                                      "image/png",
                                      "image/gif",
                                      "image/tiff",
                                  ].includes(e.target.files[0].type)
                              ) {
                                  NotificationManager.error(
                                      "File type should be pdf, doc, docx, jpg, jpeg, png, gif, tiff"
                                  );
                                  return;
                              }

                              if (e.target.files[0].size / 1024 > 1024) {
                                  NotificationManager.error(
                                      "File size should be less than 1MB"
                                  );
                                  return;
                              }
                              setEducation({
                                  ...education,
                                  resume: e.target.files[0],
                              });
                          }}
                      />
                  </Col>
              </Row>
          )}

        <Row className={"mt-4"}>
          <Col>
            <Button
                className="nextBtn startButton float-left"
                color={""}
                onClick={() => {
                    // props.setProgress(17);
                    const newProgress = Math.max(
                        (props.progress || 0) - props.progressIncrement,
                        0
                    ); // Ensure progress doesn’t go below 0
                    props.setProgress(newProgress);
                    props.setStep(1);
                    // props.switchComponent("basicInfo");
                    props.switchBack();
                    props.gotoSlide(0);
                }}
            >
              <span className="text-white font-weight-normal">Back</span>
            </Button>
            <Button
                className="beginBtn startButton float-right"
                color=""
                onClick={(e) => {
                    if (props?.lastComponent) {
                        handleFinal();
                    } else {
                        handleNext();
                    }
                }}
            >
              <span className="text-white font-weight-normal">
                {props.lastComponent ? (
                    <>
                        {props.isLoading ? (
                            <Spinner color="light" size="sm"/>
                        ) : (
                            "Submit"
                        )}
                    </>
                ) : (
                    <>Next</>
                )}
              </span>
            </Button>
          </Col>
        </Row>
      </Col>
    </div>
  );
};

export default Education;
